export const DOCUMENTS_COPY = {
    default: {
        header: {
            title: "Document Management",
            closeAria: "Close document management modal",
        },
        upload: {
            heading: "Upload New Document",
            labels: {
                type: "Document Type",
                file: "Select File",
            },
            options: {
                driverLicence: "Driver Licence",
                permit: "Permit",
                other: "Other",
            },
            button: {
                upload: "Upload Document",
                uploading: "Uploading...",
            },
        },
        list: {
            heading: "Your Documents",
            loading: "Loading documents...",
            emptyTitle: "No documents yet",
            emptyMessage: "Upload your first document to get started",
            previewButton: "Preview",
            downloadButton: "Download",
            deleteButton: "Delete",
        },
        confirm: {
            delete: "Are you sure you want to delete this document?",
        },
        errors: {
            fetch: "Failed to fetch documents",
            invalidType: "Please select an image (JPG, PNG, GIF) or PDF file",
            invalidSize: "File size must be less than 10MB",
            missingFields: "Please select a file to upload",
            uploadFailed: "Upload failed",
            deleteFailed: "Failed to delete document",
            previewFailed: "Failed to load document preview",
        },
        preview: {
            heading: "Preview Document",
            loading: "Loading preview...",
            unsupported: "Preview not available. Please download the file instead.",
            download: "Download File",
            close: "Close Preview",
        },
    },
    uk: {
        header: {
            title: "Керування документами",
            closeAria: "Закрити вікно керування документами",
        },
        upload: {
            heading: "Завантажити новий документ",
            labels: {
                type: "Тип документа",
                file: "Виберіть файл",
            },
            options: {
                driverLicence: "Водійське посвідчення",
                permit: "Перміт",
                other: "Інше",
            },
            button: {
                upload: "Завантажити документ",
                uploading: "Завантаження...",
            },
        },
        list: {
            heading: "Ваші документи",
            loading: "Завантаження документів...",
            emptyTitle: "Документів поки немає",
            emptyMessage: "Завантажте свій перший документ, щоб розпочати",
            previewButton: "Переглянути",
            downloadButton: "Завантажити",
            deleteButton: "Видалити",
        },
        confirm: {
            delete: "Видалити цей документ?",
        },
        errors: {
            fetch: "Не вдалося отримати документи",
            invalidType: "Виберіть зображення (JPG, PNG, GIF) або PDF-файл",
            invalidSize: "Розмір файлу має бути менше 10 МБ",
            missingFields: "Будь ласка, виберіть файл для завантаження",
            uploadFailed: "Не вдалося завантажити документ",
            deleteFailed: "Не вдалося видалити документ",
            previewFailed: "Не вдалося відкрити попередній перегляд документа",
        },
        preview: {
            heading: "Перегляд документа",
            loading: "Завантаження попереднього перегляду...",
            unsupported: "Попередній перегляд недоступний. Завантажте файл, будь ласка.",
            download: "Завантажити файл",
            close: "Закрити",
        },
    },
    ru: {
        header: {
            title: "Управление документами",
            closeAria: "Закрыть окно управления документами",
        },
        upload: {
            heading: "Загрузить новый документ",
            labels: {
                type: "Тип документа",
                file: "Выберите файл",
            },
            options: {
                driverLicence: "Водительское удостоверение",
                permit: "Пермит",
                other: "Другое",
            },
            button: {
                upload: "Загрузить документ",
                uploading: "Загрузка...",
            },
        },
        list: {
            heading: "Ваши документы",
            loading: "Загрузка документов...",
            emptyTitle: "Документов пока нет",
            emptyMessage: "Загрузите первый документ, чтобы начать",
            previewButton: "Просмотр",
            downloadButton: "Скачать",
            deleteButton: "Удалить",
        },
        confirm: {
            delete: "Удалить этот документ?",
        },
        errors: {
            fetch: "Не удалось получить документы",
            invalidType: "Выберите изображение (JPG, PNG, GIF) или PDF-файл",
            invalidSize: "Размер файла должен быть меньше 10 МБ",
            missingFields: "Пожалуйста, выберите файл для загрузки",
            uploadFailed: "Не удалось загрузить документ",
            deleteFailed: "Не удалось удалить документ",
            previewFailed: "Не удалось загрузить предварительный просмотр документа",
        },
        preview: {
            heading: "Предварительный просмотр документа",
            loading: "Загрузка предварительного просмотра...",
            unsupported: "Предварительный просмотр недоступен. Пожалуйста, скачайте файл.",
            download: "Скачать файл",
            close: "Закрыть",
        },
    },
    es: {
        header: {
            title: "Gestión de documentos",
            closeAria: "Cerrar el modal de gestión de documentos",
        },
        upload: {
            heading: "Subir nuevo documento",
            labels: {
                type: "Tipo de documento",
                file: "Seleccionar archivo",
            },
            options: {
                driverLicence: "Licencia de conducir",
                permit: "Permiso",
                other: "Otro",
            },
            button: {
                upload: "Subir documento",
                uploading: "Subiendo...",
            },
        },
        list: {
            heading: "Tus documentos",
            loading: "Cargando documentos...",
            emptyTitle: "Aún no hay documentos",
            emptyMessage: "Sube tu primer documento para comenzar",
            previewButton: "Previsualizar",
            downloadButton: "Descargar",
            deleteButton: "Eliminar",
        },
        confirm: {
            delete: "¿Eliminar este documento?",
        },
        errors: {
            fetch: "No se pudieron obtener los documentos",
            invalidType: "Selecciona una imagen (JPG, PNG, GIF) o un archivo PDF",
            invalidSize: "El archivo debe pesar menos de 10 MB",
            missingFields: "Selecciona un archivo para subir",
            uploadFailed: "No se pudo subir el documento",
            deleteFailed: "No se pudo eliminar el documento",
            previewFailed: "No se pudo cargar la vista previa del documento",
        },
        preview: {
            heading: "Vista previa del documento",
            loading: "Cargando vista previa...",
            unsupported: "La vista previa no está disponible. Por favor, descarga el archivo.",
            download: "Descargar archivo",
            close: "Cerrar",
        },
    },
};

export const STUDENT_DOCUMENTS_COPY = {
    default: {
        header: {
            title: "Student Documents Management",
            subtitle: "View and manage all documents uploaded by students",
            closeAria: "Close student documents modal",
        },
        list: {
            loading: "Loading documents...",
            emptyTitle: "No Documents Found",
            emptyMessage: "No students have uploaded documents yet.",
            previewButton: "Preview",
            downloadButton: "Download",
            deleteButton: "Delete",
        },
        confirm: {
            delete: "Are you sure you want to delete this document?",
        },
        errors: {
            fetch: "Failed to fetch documents",
            loadImage: "Failed to load image",
            deleteFailed: "Failed to delete document",
            downloadFailed: "Failed to download document",
        },
    },
    uk: {
        header: {
            title: "Керування документами студентів",
            subtitle: "Переглядайте та керуйте всіма документами, які завантажують студенти",
            closeAria: "Закрити вікно документів студентів",
        },
        list: {
            loading: "Завантаження документів...",
            emptyTitle: "Документів не знайдено",
            emptyMessage: "Жоден студент ще не завантажив документи.",
            previewButton: "Переглянути",
            downloadButton: "Завантажити",
            deleteButton: "Видалити",
        },
        confirm: {
            delete: "Видалити цей документ?",
        },
        errors: {
            fetch: "Не вдалося отримати документи",
            loadImage: "Не вдалося завантажити зображення",
            deleteFailed: "Не вдалося видалити документ",
            downloadFailed: "Не вдалося завантажити документ",
        },
    },
    ru: {
        header: {
            title: "Управление документами студентов",
            subtitle: "Просматривайте и управляйте всеми документами, загруженными студентами",
            closeAria: "Закрыть окно документов студентов",
        },
        list: {
            loading: "Загрузка документов...",
            emptyTitle: "Документы не найдены",
            emptyMessage: "Студенты ещё не загрузили документы.",
            previewButton: "Просмотр",
            downloadButton: "Скачать",
            deleteButton: "Удалить",
        },
        confirm: {
            delete: "Удалить этот документ?",
        },
        errors: {
            fetch: "Не удалось получить документы",
            loadImage: "Не удалось загрузить изображение",
            deleteFailed: "Не удалось удалить документ",
            downloadFailed: "Не удалось скачать документ",
        },
    },
    es: {
        header: {
            title: "Gestión de documentos de estudiantes",
            subtitle: "Consulta y administra todos los documentos que suben los estudiantes",
            closeAria: "Cerrar el modal de documentos de estudiantes",
        },
        list: {
            loading: "Cargando documentos...",
            emptyTitle: "No se encontraron documentos",
            emptyMessage: "Ningún estudiante ha subido documentos todavía.",
            previewButton: "Previsualizar",
            downloadButton: "Descargar",
            deleteButton: "Eliminar",
        },
        confirm: {
            delete: "¿Eliminar este documento?",
        },
        errors: {
            fetch: "No se pudieron obtener los documentos",
            loadImage: "No se pudo cargar la imagen",
            deleteFailed: "No se pudo eliminar el documento",
            downloadFailed: "No se pudo descargar el documento",
        },
    },
};
